import React, { useEffect } from 'react';
import { ONE_HOUR_MS, ResourcesState } from './ResourcesState';
import { useInstance } from '@meraki-internal/react-dependency-injection';

export const EnsureResourcesLoaded: React.FC = () => {

    const resourcesState = useInstance(ResourcesState);

    // load if stale or never loaded
    const loadIfNeeded = () => {
        if (!resourcesState.isLoaded() || resourcesState.isStale()) {
            resourcesState.load();
        }
    };

    useEffect(() => {

        // check on page load
        loadIfNeeded();

        // check again every hour in case they never leave the page
        const interval = setInterval(() => {
            loadIfNeeded();
        }, ONE_HOUR_MS);

        // clear interval when they leave the page
        return () => clearInterval(interval);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
